import { useEffect, useRef } from 'react'

const MAX_TIMEOUT_MS = 2_147_483_647

export function useParticipantWorkflowRefresh(
  coolingOffEndsAt: string | null | undefined,
  refetch: () => Promise<unknown>,
) {
  const triggeredDeadline = useRef<string | null>(null)

  useEffect(() => {
    if (!coolingOffEndsAt) {
      triggeredDeadline.current = null
      return
    }
    const deadline = Date.parse(coolingOffEndsAt)
    if (Number.isNaN(deadline)) return

    let timeout: ReturnType<typeof setTimeout> | undefined
    const schedule = () => {
      const remaining = deadline - Date.now()
      if (remaining <= 0) {
        if (triggeredDeadline.current === coolingOffEndsAt) return
        triggeredDeadline.current = coolingOffEndsAt
        void refetch()
        return
      }
      timeout = setTimeout(schedule, Math.min(remaining, MAX_TIMEOUT_MS))
    }
    schedule()
    return () => {
      if (timeout) clearTimeout(timeout)
    }
  }, [coolingOffEndsAt, refetch])
}
